<template>
    <ListenerSearch v-if="isListenerMobile" />
    <Search v-else />
</template>

<script>
import Search from './Search.vue'
import ListenerSearch from './ListenerSearch.vue'

export default {
    name: 'LibrarySearchEntry',
    components: {
        Search,
        ListenerSearch
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
